import styled from "styled-components";

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 140px;
  height: 140px;
`;

export const PartImg = styled.img`
  max-width: 100%;
  max-height: 100%;
`;
